import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addShippingPayersApi, deleteShippingPayersApi, getShippingPayersApi, updateShippingPayersApi } from "../../../services/partners/settings/shippingPayersService";


export const getAllShippingPayers = createAsyncThunk("partner/getAllShippingPayers", async (filters, { dispatch }) => {
  const response = await getShippingPayersApi(filters);
  return response.response;
});

export const addShippingPayers = createAsyncThunk("partner/addShippingPayers", async (duration, { dispatch, getState }) => {
  try {
    const response = await addShippingPayersApi(duration);
    const data = await response.response;
    toast.success("Add Partner Shipping Payers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updateShippingPayers = createAsyncThunk("partner/updateShippingPayers", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateShippingPayersApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Shipping Payers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deleteShippingPayers = createAsyncThunk("partner/deleteShippingPayers", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteShippingPayersApi(id);
    const data = await response.response;
    toast.success("Deleted Shipping Payers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnersShippingPayersAdapter = createEntityAdapter({});

export const { selectAll: selectShippingPayers, selectById: selectShippingPayersId } = partnersShippingPayersAdapter.getSelectors(
  (state) => state.partner.partnerShippingPayers
);

const shippingPayerSlice = createSlice({
  name: "partnerShippingPayers",
  initialState: partnersShippingPayersAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerShippingPayers",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerShippingPayersSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerShippingPayers",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllShippingPayers.fulfilled]: partnersShippingPayersAdapter.setAll,
  },
});

export const { setPartnerShippingPayersSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = shippingPayerSlice.actions;

export default shippingPayerSlice.reducer;
